












import Vue from "vue";
export default Vue.extend({
  props: {
    profile: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      document: [
        {
          text: "Documentos",
          icon: "fas fa-folder",
          to: { name: `document${this.profile}` },
        },
      ],
    };
  },
});
